
import { useState } from "react";
import { Input } from "./ui/input";
import { Mail } from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { sendToGoogleChat } from "@/utils/googleChat";
import { toast } from "sonner";

const GOOGLE_CHAT_WEBHOOK_URL = "VOTRE_WEBHOOK_URL_ICI";

const Footer = () => {
  const [email, setEmail] = useState("");
  const { t } = useTranslation(["footer", "common"]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    try {
      const formattedMessage = `
📬 *Nouvelle inscription newsletter !* 📬

📧 *Email*
• ${email}

⏰ Reçu le ${new Date().toLocaleString('fr-FR')}

_Génial ! Notre communauté s'agrandit ! 🌱 
Une nouvelle personne souhaite suivre nos actualités ! 🎯_
`;

      await sendToGoogleChat(GOOGLE_CHAT_WEBHOOK_URL, {
        text: formattedMessage,
      });

      console.log("Newsletter subscription:", email);
      toast.success(t("newsletter.success"));
      setEmail("");
    } catch (error) {
      console.error(error);
      toast.error(t("common:error"));
    }
  };

  return (
    <footer className="bg-card border-t border-border">
      <div className="container-custom py-16">
        <div className="max-w-3xl mx-auto">
          <div className="flex flex-col items-center space-y-12">
            {/* Newsletter Section */}
            <div className="w-full text-center space-y-6">
              <div className="space-y-2">
                <h3 className="text-2xl font-semibold text-foreground">
                  {t("newsletter.title")}
                </h3>
                <p className="text-muted-foreground">
                  {t("newsletter.description")}
                </p>
              </div>
              
              <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
                <div className="relative flex-1">
                  <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground w-5 h-5" />
                  <Input
                    type="email"
                    placeholder={t("newsletter.placeholder")}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="pl-10"
                    required
                  />
                </div>
                <button
                  type="submit"
                  className="bg-brand-blue hover:bg-brand-blue/90 dark:bg-brand-orange dark:hover:bg-brand-orange/90 text-white px-6 py-2 rounded-md transition-colors"
                >
                  {t("newsletter.button")}
                </button>
              </form>
            </div>

            {/* Legal Links */}
            <nav className="flex flex-wrap justify-center gap-x-8 gap-y-3">
              <Link 
                to="/mentions-legales" 
                className="text-muted-foreground hover:text-foreground transition-colors"
              >
                {t("links.legal")}
              </Link>
              <Link 
                to="/politique-de-confidentialite" 
                className="text-muted-foreground hover:text-foreground transition-colors"
              >
                {t("links.privacy")}
              </Link>
              <Link 
                to="/cgu" 
                className="text-muted-foreground hover:text-foreground transition-colors"
              >
                {t("links.terms")}
              </Link>
            </nav>

            {/* Copyright */}
            <div className="pt-8 border-t border-border w-full">
              <p className="text-center text-muted-foreground">
                {t("copyright")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
